var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49048 6.16577L2.16638 11.4899C2.07449 11.5818 1.92551 11.5818 1.83362 11.4899L0.835354 10.4916C0.743466 10.3997 0.743466 10.2507 0.835354 10.1588L4.99481 5.9994L0.835354 1.83994C0.743466 1.74806 0.743466 1.59908 0.835353 1.50719L1.83362 0.50892C1.92551 0.417032 2.07449 0.417032 2.16638 0.50892L7.49048 5.83302C7.58365 5.92619 7.58365 6.0726 7.49048 6.16577Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c1ad0bd5bc75e1598303d93d1215a087.svg";
export { ForwardRef as ReactComponent };